<template>
    <div class="Tutor">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-group</v-icon>
                                Lista de Tutores
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="tutorEstado"
                                    label="Tutor"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadTutor()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Tutor</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="TUTORES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>
                                            {{
                                                props.item.nombre
                                                    ? props.item.nombre +
                                                      " " +
                                                      props.item.apellido_paterno +
                                                      " " +
                                                      props.item.apellido_materno
                                                    : "-"
                                            }}
                                        </td>
                                        <td>{{ props.item.cedula ? props.item.cedula : "-" }}</td>
                                        <td>{{ props.item.sexo ? props.item.sexo.nombre : "-" }}</td>
                                        <td>{{ props.item.movil ? props.item.movil : "-" }}</td>
                                        <td>{{ props.item.email ? props.item.email : "-" }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                        </td>

                                        <td class="pl-0">
                                            <v-layout class="justify-end">
                                                <div class="action-column" style="width: 208px">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :disabled="loading || menuLocked"
                                                                @click="openDetails(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver detalles</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="orange"
                                                                :disabled="loading || menuLocked"
                                                                @click="openForm(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Editar Tutor</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="red"
                                                                :disabled="loading || menuLocked"
                                                                @click="deleteItem(props)"
                                                            >
                                                                <v-icon medium v-on="on">fa-trash</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Eliminar Tutor</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :loading="loadingHistory"
                                                                :disabled="loading || menuLocked"
                                                                @click="loadHistory(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-archive</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver historial</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-layout>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen tutores registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <tutor-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </tutor-form>

        <tutor-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails"> </tutor-details>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Tutor'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
const TimeLine = () => import("@/components/widgets/records-time-line/time-line")
const TutorDetails = () => import("@/components/cobranza/tutor/tutor-details")
const TutorForm = () => import("@/components/cobranza/tutor/tutor-form")

export default {
    components: { TutorForm, TutorDetails, TimeLine },
    props: {},
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Nombre", value: "nombre" },
            { text: "Cédula", value: "cedula" },
            { text: "Sexo", value: "sexo_id" },
            { text: "Móvil", value: "celular" },
            { text: "Correo", value: "email" },
            { text: "Estado", value: "estado" },
            { sortable: false }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteTutorConfirmId: "",

        menuLocked: false,

        showDetails: false,
        detailsItem: null,

        //estado de los tutores a cargar del back
        tutorEstado: "1",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado) {
            this.loading = true
            this.$store.dispatch("LOAD_TUTORES", { filter: this.filter.search, tutorEstado: estado }).then(result => {
                this.loading = false
                this.totalItems = result
            })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar Tutor"
                this.editItem = item
            } else {
                this.title = "Nuevo Tutor"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteTutorConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteTutorConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_TUTOR", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteTutorConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteTutorConfirmId = ""
            props.expanded = !props.expanded
        },

        loadTutor() {
            this.loadData(this.tutorEstado)
        },

        searchData: _.debounce(function() {
            this.loadData(this.tutorEstado)
        }, 1000),

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(item) {
            if (!this.TUTORES.filter(el => el.id === item.id)[0].escolaridad) {
                //condicion para saber si los datos de este tutor ya se cargaron para no volver a pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_TUTOR_DETAILS", item).then(error => {
                    if (error === null) {
                        this.detailsItem = item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            } else {
                this.detailsItem = item
                this.showDetails = true
            }
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Tutor")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        }
    },

    computed: {
        ...mapGetters(["TUTORES"]),

        pagination: {
            get: function() {
                return this.$store.getters.TUTORES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_TUTORES_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                this.loadData(this.tutorEstado)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>
